import { useEffect, useRef, useState } from "react";
import { useHandshakeSessionActions } from "@/hooks/useHandshakeSessionActions";
import { useAdminHandshakeSessionDetail } from "@/hooks/useHandshakeSessionDetail";
import { scrollParentToBottom } from "@/lib/scrollParent";

export function useAdminHandshakeSessionPanel(sessionId: string) {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const sessionQuery = useAdminHandshakeSessionDetail(sessionId);
  const actions = useHandshakeSessionActions(sessionId, { admin: true });

  useEffect(() => {
    scrollParentToBottom(messagesEndRef.current);
  }, [sessionQuery.data?.messages.length]);

  return {
    ...sessionQuery,
    ...actions,
    messagesEndRef,
    showCancelConfirm,
    setShowCancelConfirm,
  };
}
